import { useSimulatorStore } from '../../stores/useSimulatorStore';
import { SegmentOverviewCards } from './SegmentOverviewCards';
import { SegmentDemographicProfiles } from './SegmentDemographicProfiles';
import { DemographicCrossTab } from './DemographicCrossTab';
import { SegmentPriceCurves } from './SegmentPriceCurves';
import { SegmentDemandTable } from './SegmentDemandTable';
import { SegmentPackageMatrix } from './SegmentPackageMatrix';
import { BimodalVisualization } from './BimodalVisualization';
import { NoneAnalysisPanel } from './NoneAnalysisPanel';
import { VALID_PRICES } from '../../data/conjointData';
import { formatPrice } from '../../lib/formatters';
import { Select } from '../common/Select';
import { InsightCard } from '../ai/InsightCard';
import { InfoButton } from '../common/Tooltip';

export function SegmentDeepDiveTab() {
  const selectedPrice = useSimulatorStore(s => s.selectedPrice);
  const setSelectedPrice = useSimulatorStore(s => s.setSelectedPrice);

  return (
    <div>
      <InsightCard tabId="segments" />

      <div className="flex items-center gap-4 mb-6">
        <label className="text-sm text-secondary flex items-center gap-1">Selected Price: <InfoButton helpKey="selectedPrice" size={11} /></label>
        <Select
          value={selectedPrice}
          options={VALID_PRICES.map(p => ({ value: p, label: formatPrice(p) }))}
          onChange={v => setSelectedPrice(parseInt(v))}
          className="w-40"
        />
      </div>

      <SegmentOverviewCards selectedPrice={selectedPrice} />

      <div className="mt-6">
        <SegmentDemographicProfiles />
      </div>

      <div className="mt-6">
        <SegmentPackageMatrix />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mt-6">
        <SegmentPriceCurves selectedPrice={selectedPrice} />
        <div className="hidden md:block">
          <SegmentDemandTable />
        </div>
      </div>

      <div className="mt-6">
        <DemographicCrossTab />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mt-6">
        <div className="hidden md:block">
          <BimodalVisualization selectedPrice={selectedPrice} />
        </div>
        <NoneAnalysisPanel />
      </div>
    </div>
  );
}
